module.exports = __webpack_public_path__ + "static/media/pic19.9b966568.jpg";